import { render } from "./SegmentedControl.vue?vue&type=template&id=2d52156c&scoped=true"
import script from "./SegmentedControl.vue?vue&type=script&lang=js"
export * from "./SegmentedControl.vue?vue&type=script&lang=js"

import "./SegmentedControl.vue?vue&type=style&index=0&id=2d52156c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d52156c"]])

export default __exports__